import { P2GText } from '@parcel2go/core-ui';

import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { AsyncLinks } from './AsyncLinks';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  group: ProviderGroup;
}

const ProviderGroupSummaryBookedLabels: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <AsyncLinks
      variant="label"
      tag={`Order ${props.group.ShipResponse.Reference}`}
      links={props.group.ShipResponse?.Links}
      title={null}
      match={(x) => x.Type.startsWith('ORDER-LABELS-')}
    >
      <P2GText component="p" colour="primary">
        <Trans
          i18nKey="PROVIDER_GROUP_SUMMARY_BOOKED_DOWNLOAD_LABELS"
          t={t}
          defaults="<strong>Download Your Labels</strong>"
        />
      </P2GText>
    </AsyncLinks>
  );
};

export default ProviderGroupSummaryBookedLabels;
